/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const supportedCountryLanguageCombination = {
  ad: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  al: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ae: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  am: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ar: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  at: {
    locales: ['de_DE'],
    default: 'de_DE',
  },
  au: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  az: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ba: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  be: {
    locales: ['fr_FR', 'nl_NL'],
    default: 'fr_FR',
  },
  bg: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  bh: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  bn: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  bo: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  br: {
    locales: ['pt_BR', 'en_GB'],
    default: 'pt_BR',
  },
  by: {
    locales: ['ru_RU'],
    default: 'ru_RU',
  },
  ca: {
    locales: ['en_US', 'fr_FR'],
    default: 'en_US',
  },
  ch: {
    locales: ['en_GB', 'de_DE', 'fr_FR', 'it_IT'],
    default: 'de_DE',
  },
  cl: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  cn: {
    locales: ['en_GB', 'zh_CN'],
    default: 'zh_CN',
  },
  co: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  cr: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  cy: {
    locales: ['en_GB', 'ru_RU'],
    default: 'en_GB',
  },
  cz: {
    locales: ['en_GB', 'cs_CZ'],
    default: 'cs_CZ',
  },
  de: {
    locales: ['de_DE'],
    default: 'de_DE',
  },
  dk: {
    locales: ['en_GB', 'da_DK'],
    default: 'da_DK',
  },
  do: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  ec: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  ee: {
    locales: ['et_EE', 'ru_RU', 'en_GB'],
    default: 'et_EE',
  },
  eg: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  es: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  fi: {
    locales: ['en_GB', 'fi_FI'],
    default: 'fi_FI',
  },
  fr: {
    locales: ['fr_FR'],
    default: 'fr_FR',
  },
  gb: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ge: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  gi: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  gp: {
    locales: ['fr_FR'],
    default: 'fr_FR',
  },
  gr: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  gt: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  hk: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  hn: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  hr: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ht: {
    locales: ['fr_FR'],
    default: 'fr_FR',
  },
  hu: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  id: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  ie: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  il: {
    locales: ['en_GB', 'he_IL'],
    default: 'en_GB',
  },
  in: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  is: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  it: {
    locales: ['it_IT'],
    default: 'it_IT',
  },
  jo: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  jp: {
    locales: ['en_GB', 'ja_JP'],
    default: 'ja_JP',
  },
  ke: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  kh: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  kr: {
    locales: ['ko_KR', 'en_GB'],
    default: 'ko_KR',
  },
  kw: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  kz: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  lb: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  li: {
    locales: ['en_GB', 'de_DE', 'fr_FR', 'it_IT'],
    default: 'de_DE',
  },
  lk: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  lt: {
    locales: ['ru_RU', 'lt_LT', 'en_GB'],
    default: 'lt_LT',
  },
  lu: {
    locales: ['de_DE', 'fr_FR'],
    default: 'de_DE',
  },
  lv: {
    locales: ['ru_RU', 'lv_LV', 'en_GB'],
    default: 'lv_LV',
  },
  ma: {
    locales: ['ar_AE', 'fr_FR'],
    default: 'fr_FR',
  },
  mc: {
    locales: ['fr_FR', 'en_GB'],
    default: 'fr_FR',
  },
  md: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  mk: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  mn: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  mt: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  mx: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  my: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  nc: {
    locales: ['fr_FR'],
    default: 'fr_FR',
  },
  nl: {
    locales: ['en_GB', 'nl_NL'],
    default: 'nl_NL',
  },
  no: {
    locales: ['en_GB', 'no_NO'],
    default: 'no_NO',
  },
  nz: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  om: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  pa: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  pe: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  pf: {
    locales: ['fr_FR'],
    default: 'fr_FR',
  },
  ph: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  pk: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  pl: {
    locales: ['en_GB', 'pl_PL'],
    default: 'pl_PL',
  },
  pr: {
    locales: ['es_ES', 'en_US'],
    default: 'es_ES',
  },
  pt: {
    locales: ['en_GB', 'pt_PT'],
    default: 'pt_PT',
  },
  py: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  qa: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  ro: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  rs: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  sa: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  se: {
    locales: ['en_GB', 'sv_SE'],
    default: 'sv_SE',
  },
  sg: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  si: {
    locales: ['en_GB', 'sl_SI'],
    default: 'sl_SI',
  },
  sk: {
    locales: ['en_GB', 'cs_CZ'],
    default: 'cs_CZ',
  },
  sv: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  sy: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  th: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  tr: {
    locales: ['en_GB', 'tr_TR'],
    default: 'tr_TR',
  },
  tt: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  tw: {
    locales: ['zh_TW', 'en_GB'],
    default: 'zh_TW',
  },
  ua: {
    locales: ['uk_UA', 'en_GB'],
    default: 'uk_UA',
  },
  us: {
    locales: ['en_US'],
    default: 'en_US',
  },
  uy: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  ve: {
    locales: ['es_ES'],
    default: 'es_ES',
  },
  vn: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  xa: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  xd: {
    locales: ['ar_AE', 'en_GB'],
    default: 'en_GB',
  },
  ye: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
  za: {
    locales: ['en_GB'],
    default: 'en_GB',
  },
}
